// DownloadButton.js
import React from 'react';

const DownloadButton = ({ fileUrl }) => {
  const handleDownload = () => {
    window.open("https://drive.google.com/file/d/1eptVCMUR0WCFpRI7mT2n5Qq8NNMN7Qbf/view?usp=sharing", '_blank');
  };

  return (
    <button
      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded shadow-lg mt-6 mx-10"
      onClick={handleDownload}
    >
      Download Resume
    </button>
  );
};

export default DownloadButton;
